import { QueryKey } from '@tanstack/react-query';
import useHandleTrpcMutation from 'hooks/ui/useHandleTrpcMutation';
import api from 'lib/trpcClient';

export default function useInvestorUsers({
  vehicleApplicationQueryKey,
}: {
  vehicleApplicationQueryKey: QueryKey;
}) {
  const addInvestorUser = api.vehicleApplication.addInvestorUser.useMutation(
    useHandleTrpcMutation()({
      successMessage: 'User added successfully.',
      invalidations: [vehicleApplicationQueryKey],
    }),
  );

  const updateInvestorUser =
    api.vehicleApplication.updateInvestorUser.useMutation(
      useHandleTrpcMutation()({
        successMessage: 'User updated successfully.',
        invalidations: [vehicleApplicationQueryKey],
      }),
    );

  const removeInvestorUser =
    api.vehicleApplication.removeInvestorUser.useMutation(
      useHandleTrpcMutation()({
        successMessage: 'User removed successfully.',
        invalidations: [vehicleApplicationQueryKey],
      }),
    );
  const handleAddInvestorUser = addInvestorUser.mutate;
  const handleUpdateInvestorUser = updateInvestorUser.mutate;
  const handleRemoveUser = removeInvestorUser.mutate;

  return {
    handleUpdateInvestorUser,
    handleRemoveUser,
    handleAddInvestorUser,
    isLoading:
      addInvestorUser.isPending ||
      updateInvestorUser.isPending ||
      removeInvestorUser.isPending,
  };
}
